import {withTranslation} from '@wix/yoshi-flow-editor'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {SeatingPlanRuntimeProps} from './interfaces'
import {SeatingPlan as Presentation} from './seating-plan'

const mapRuntime = ({
  state: {
    seating: {plan, loading, selectedPlaces},
    tickets,
    selectedTickets,
    event,
  },
  actions: {selectTicket, unselectTicket, checkout, selectSeat, unselectSeat},
}: DetailsPageAppProps): SeatingPlanRuntimeProps => ({
  selectedPlaces,
  plan,
  tickets,
  selectedTickets,
  selectTicket,
  unselectTicket,
  checkout,
  loading,
  event,
  selectSeat,
  unselectSeat,
})

export const SeatingPlanModal = connect<{}, SeatingPlanRuntimeProps>(mapRuntime)(withTranslation()(Presentation))
export * from './interfaces'
